export default "__VITE_ASSET__ba57963b__"